export const project = 'unite'; // need this for when we dynamically import utils

/**
 *
 * @param {Object} win - The window object. Contains the gtag function.
 * @param {Object} payload - The payload to send coming from mappings.
 *
 */

export const sending = ({ data: payload, event, eventData, preview, win }) => {
	// Event Viewer
	const reportsForEventViewer = [];
	const reportsForNewRelic = [];
	const sender = 'window.udTag()';

	if (event !== 'ddc.wstagging.first') {
		if (event === 'asc_pageview') {
			if (!preview) {
				// eslint-disable-next-line no-param-reassign
				win.ud_asc_dataLayer = win.ud_asc_dataLayer || [];

				// eslint-disable-next-line no-param-reassign
				win.udTag = (...args) => {
					win.ud_asc_dataLayer.push(args);
				};

				win.udTag('init', payload);

				win.sessionStorage?.setItem?.(
					'SaveUniteCorrelationId',
					win.udCorrelation?.get?.()
				);
			}

			reportsForEventViewer.push({
				payload,
				sender
			});
			reportsForNewRelic.push({
				clientEventName: 'init',
				sender
			});
		}

		if (event.startsWith('asc_')) {
			const {
				element: _element,
				event: _event,
				product_name: productName,
				...uniteEventData
			} = eventData;

			const partnerCode =
				event === 'asc_retail_process' ||
				productName === 'accelerate_my_deal'
					? { partnerCode: 'ddcacceleratedr' }
					: {};
			if (!preview) {
				win.udTag('event', event, {
					...uniteEventData,
					...partnerCode
				});
			}

			reportsForEventViewer.push({
				payload: {
					...uniteEventData,
					...partnerCode
				},
				sender
			});
			reportsForNewRelic.push({
				clientEventName: event,
				sender
			});
		}
	}

	return {
		reportsForEventViewer,
		reportsForNewRelic
	};
};
